import { useState } from 'react';
import styles from './PlatformIcon.module.css';

/**
 * Platform logo URL from Parrot CDN
 * Examples:
 *   - "Netflix" → netflix.png
 *   - "Amazon Prime Video" → amazon_prime_video.png
 *   - "Disney+" → disney_.png
 */
const PLATFORM_LOGO_URL = (name: string, width = 48) =>
  `https://cdn-fastly.parrotanalytics.com/platforms/tv360/${name.toLowerCase().replace(/[^a-z0-9]/g, '_')}.png?width=${width}`;

interface PlatformIconProps {
  name: string;
  size?: number;
  className?: string;
}

/**
 * Platform logo with graceful fallback to first letter
 */
export function PlatformIcon({ name, size = 24, className }: PlatformIconProps) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <div
        className={`${styles.fallback} ${className || ''}`}
        style={{ width: size, height: size, fontSize: size * 0.45 }}
      >
        {name.charAt(0).toUpperCase()}
      </div>
    );
  }

  return (
    <img
      src={PLATFORM_LOGO_URL(name, size * 2)} // 2x for retina
      alt={name}
      className={`${styles.icon} ${className || ''}`}
      style={{ width: size, height: size }}
      onError={() => setFailed(true)}
    />
  );
}

/**
 * Platform colors for badges/accents
 */
export const PLATFORM_COLORS: Record<string, string> = {
  'Netflix': '#E50914',
  'Amazon Prime Video': '#00A8E1',
  'Disney+': '#113CCF',
  'HBO Max': '#B535F6',
  'Max': '#B535F6',
  'Hulu': '#1CE783',
  'Apple TV+': '#000000',
  'Paramount+': '#0064FF',
  'Peacock': '#000000',
  'Discovery+': '#1F69FF',
  'STARZ': '#000000',
};

export function getPlatformColor(platform: string): string {
  for (const [key, color] of Object.entries(PLATFORM_COLORS)) {
    if (platform.toLowerCase().includes(key.toLowerCase())) {
      return color;
    }
  }
  return '#666666';
}
